import React from 'react';
import AddItem from './AddItem';
import UpdateLogo from './UpdateLogo';
import UpdateCover from './UpdateCover';
import { Link } from 'react-router-dom';

const Admin = () => {
    document.title = 'SIHAH - Admin';

    return (
        <section id="admin" className="text-center container">
            <div className="row mx-0 mt-3">
                <AddItem />
                <div className="col-md-6 mb-5">
                    <article className="shadow p-md-5 px-3 py-4 h-100">
                        <h4 className="title mt-md-5 mb-4"><b>Update Details</b></h4>
                        <Link onClick={() => window.scrollTo(0, 0)} to="/update" className="btn btn-one text-white">Edit Items</Link>
                    </article>
                </div>
                <UpdateLogo />
                <UpdateCover />
            </div>
        </section>
    );
};

export default Admin;